// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsMultiLanguageSettingsRemoveTranslationsResult = objectOf({
  success: boolean,
});
